<!--
 * @Description: 手机登录组件
 * @Author: wq
 * @Date: 2022-05-19 16:43:52
-->
<template>
   <div class="body-mobile-login">
     <div class="div-title">手机登录</div>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px" style="margin-top: 88px; width: 366px;">
        <el-form-item label="手机号：" prop="username">
          <el-input class="input-radius" placeholder="请输入手机号" v-model="form.username" 
            clearable :autofocus="true" @input="inputPhone" @keyup.enter.native="handleLogin('form')">
          </el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="code" style="margin-top: 30px;">
          <div class="bk-code">
            <el-input class="input-radius input-code" placeholder="请输入短信验证码" v-model="form.code" clearable
              @keyup.enter.native="handleLogin('form')">
            </el-input>
            <el-button plain class="btn-code" @click="handeleCodeClick">{{codeBtn.codeText}}</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div style="width: 366px; margin-top: 30px;">
        <el-button class="btn-login" type="primary" @click="handleLogin('form')">确 认</el-button>
      </div>
      <slider-vcode-dialog :visible="showSliderDlg" @close-dialog="handleCloseSliderDialog"/>
   </div>
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
  name: 'MobileLogin',
  components: {
  },

  data() {
    let validateMobile = (_rule, value, callback) => {
			if (!value) {
			  callback(new Error('请输入手机号'));
			} else if (!this.commonUtil.validateMobile(value)) {
			  callback(new Error('请输入正确的手机号码'));
			} else {
			  callback();
			}
		};

    return {
      form: {
        'username': '',
        'code': '',
      },
      rules: {
        username: [{required: true, validator: validateMobile, trigger: 'blur'}],
        code: [{required: true, message: '请输入短信验证码', trigger: 'blur'}]
      },
      //验证码按钮
			codeBtn: {
        codeTime: 60,
        codeText: "获取验证码",
        codeStatus: true
			},
      codeInterval: null,

      showSliderDlg: false,
    }
  },
  
  methods:{
    sendSmsCode(imgVcode) {
      if (!this.codeBtn.codeStatus) return;

      let url = this.commonUtil.fillUrlArgments(this.commonUrl.URL_COMMON_SM_VCODE, 'login');
      let param = { mobile: this.form.username, 'imageVcode': imgVcode };
      let requestData = {
          method: 'POST',
          url: url,
          contentType: this.commonConst.CNTYPE_URLENCODED,
          param: param,
      };
      this.vueRequest(requestData).then(result => {
        if (!result) return;
        this.handleCodeTimer();
      });
    },

    handleCodeTimer() {
      this.codeBtn.codeStatus = false;
      this.codeInterval = setInterval(() => {
        let codetime = this.codeBtn.codeTime;
        codetime--;
        this.codeBtn.codeTime = codetime;
        this.codeBtn.codeText = '倒计时' + codetime + "s";
        if (codetime < 1) {
          clearInterval(this.codeInterval);
          this.codeBtn.codeText = "重新获取";
          this.codeBtn.codeTime = 60;
          this.codeBtn.codeStatus = true;
        }else{
          this.codeBtn.codeStatus = false;
        }
      }, 1000);
    },

    handeleCodeClick() {
      if (!this.codeBtn.codeStatus) {return;}
      this.$refs.form.validateField('username');
      if (!this.form.username || !this.commonUtil.validateMobile(this.form.username)) return;
      this.showSliderDialog();
    },

    showSliderDialog() {
      this.showSliderDlg = true;
    },

    /**
     * succ: true/false = 验证成功/取消验证（点X关闭了对话框）
     * imgVcode: 验证码值，succ=true时有效
     */
    handleCloseSliderDialog(succ, imgVcode) {
      this.showSliderDlg = false;
      if (succ) this.sendSmsCode(imgVcode);
    },

    handleLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.processLogin();
      });
    },

    processLogin() {
      let username = this.commonConst.LOIGN_PREFIX_VERIFY_CODE + 'inst+' + this.form.username + "$$_register";
      let paramForm = {
        'username': username,
        'password': this.form.code
      }
      let [header, esParam] = this.encryptionUtil.encryptParamList(paramForm, ['password'],
        Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY);
      let requestData = {
        method: 'POST',
        url: Constant.URL_LOGIN,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_FORM_DATA,
      };
      this.vueRequest(requestData).then(data => {
        if (data != null) {
          this.$emit('loginSuccess');
        }
      })
    },

    // 手机号输入改变
		inputPhone() {
			//只能输入数字，最长11位
			this.form.username = this.commonUtil.filterDigitals(this.form.username);
			if (this.form.username.length > 11) {
        this.form.username = this.form.username.slice(0, 11);
      }
		}, 
  },

  destroyed() {
    clearInterval(this.codeInterval);
    this.codeBtn.codeText = "获取验证码";
    this.codeBtn.codeTime = 60;
    this.codeBtn.codeStatus = true;
  },
}
</script>

<style scoped>
.body-mobile-login {
  width: 100%;
  margin: 0;
  border: solid 0px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.div-title {
  margin-top: 126px;
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  line-height: 28px;
}
.input-radius {
  width: 287px;
  height: 40px;
  border-radius: 4px;
}
.bk-code {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.input-code {
  width: 159px;
}
.btn-code {
  border-radius: 4px;
  border: 1px solid #2A98FF;
  font-size: 14px;
  color: #2A98FF;
}
.btn-login {
  width:100%; 
  height: 50px;
  background: #3A7FF3;
  border-color: #3A7FF3;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
}
</style>
<style>
.body-mobile-login .el-form-item__label {
  color: #657180 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/login/components/MobileLogin.vue